<script>
    import { fly } from "svelte/transition";
    import { createEventDispatcher } from "svelte";
    import { portal } from "svelte-portal";
    import KeyButton from "./KeyButton.svelte";
    export let show = false;
    const clsPrefix = "keypad";
    let items = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        "Q",
        "W",
        "E",
        "R",
        "T",
        "Y",
        "U",
        "I",
        "O",
        "P",
        "A",
        "S",
        "D",
        "F",
        "G",
        "H",
        "J",
        "K",
    ];
    let others = ["L", "Z", "X", "C", "V", "B", "N", "M"];
    export let value = "";
    const dispatch = createEventDispatcher();
    const select = (num) => () => (value += num);
    const del = () => (value = value.slice(0, value.length - 1));
    const submit = () => dispatch("submit");
</script>

{#if show}
    <div class={clsPrefix} transition:fly={{ y: 200 }} use:portal={"body"}>
        {#each items as item}
            <KeyButton
                type="button"
                class={`${clsPrefix}-btn`}
                on:click={select(item)}>{item}</KeyButton
            >
        {/each}
        <KeyButton
            disabled={!value}
            class={`${clsPrefix}-btn ${clsPrefix}-btn-del`}
            on:click={del}>删除</KeyButton
        >
        {#each others as item}
            <KeyButton
                type="button"
                class={`${clsPrefix}-btn`}
                on:click={select(item)}>{item}</KeyButton
            >
        {/each}
        {#if items && items.length > 0}
            <KeyButton
                disabled={!value}
                class={`${clsPrefix}-btn ${clsPrefix}-btn-ok`}
                on:click={submit}>完成</KeyButton
            >
        {/if}
    </div>
{/if}

<style lang="less">
    @import "./keypad.less";
</style>
